import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'wholeDollar', standalone: false})
export class WholeDollarPipe implements PipeTransform {
	transform(value: string | number): string {
		const numericValue = typeof value === 'string' ? parseFloat(value) : value;
		if (isNaN(numericValue)) {
			return '$0';
		}
		const roundedValue = Math.round(numericValue);
		return `$${roundedValue.toLocaleString()}`;
	}
}
